import React from "react";
import Flagship from "../../core/flagship";
import Field from "../misc/Field";
import { connect } from "react-redux";
import {
  Table,
  Loader,
  Header,
  Modal,
  Button,
  Select,
  Icon,
} from "semantic-ui-react";
import { shouldShowField, empty } from "../../utils/helpers";
import FlightField from "../misc/FlightField";

class IoProductForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editName = this.editName.bind(this);
    this.onSelectService = this.onSelectService.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.addError = this.addError.bind(this);
    this.clearError = this.clearError.bind(this);
    this.onCopyFromRFP = this.onCopyFromRFP.bind(this);
    this.getSubServiceFields = this.getSubServiceFields.bind(this);
    this.checkRequired = this.checkRequired.bind(this);
    this.setFlightSubFieldsMissing = this.setFlightSubFieldsMissing.bind(this);
  }

  getInitialState() {
    return {
      ioProductForm: [],
      ioProductData: {},
      ioProductPricingFields: [],
      ioProductServices: [],
      serviceOptions: [],
      editingName: false,
      errors: [],
      newIoProductService: null,
      newIoProductName: null,
      newIoProductServiceNiceName: null,
      newIoProductLaunch: null,
      lineItemId: null,
      hasCopiedFromRFP: false,
      flights: [{}],
      flighted: false,
      requiredMissing: true,
      flightSubFieldsMissing: false,
    };
  }

  componentDidMount() {
    let self = this;

    // Get line items attached to RFP for this IO. Only need to pull services to populate available options in dropdown.
    Flagship.get(
      "/io-product/services-available/" + this.props.recordId,
      {},
      function (response) {
        if (response.data.success === true) {
          let services = [];

          if (!empty(response.data.results)) {
            response.data.results.map(function (item) {
              services.push({
                key: item.id,
                value: item.line_item_type,
                text: item.line_item_name,
              });
            });
            self.setState({
              ioProductServices: services,
              serviceOptions: services.map(function (option, i) {
                return {
                  value: option.text,
                  text: option.text,
                  key: i,
                };
              }),
            });
          }
        } else {
          Flagship.error(
            "Error getting available IO product services from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting available IO product services from Flagship API server: " +
            err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  onCopyFromRFP() {
    let self = this;
    Flagship.get(
      "line-item/read/" + this.state.lineItemId,
      {
        withData: true,
      },
      function (response) {
        if (response.data.success === true) {
          let productData = self.state.ioProductData;

          response.data.data.map(function (item) {
            productData[item.field_id] = item.field_value;
          });

          self.setState(
            {
              loading: false,
              hasCopiedFromRFP: true,
              ioProductData: productData,
              flights: response.data.result.flights,
            },
            function () {
              Flagship.notify("Copied info from RFP.");
              self.checkRequired();
            }
          );
        } else {
          Flagship.error(
            "Error getting RFP line item data from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting RFP line item data from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  checkRequired() {
    let requiredMissing = false;
    let self = this;

    this.state.ioProductForm.length &&
      this.state.ioProductForm.map(function (item) {
        if (
          self.state.flightSubFieldsMissing ||
          ((item.required === true || item.required === 1) &&
            empty(self.state.ioProductData[item.field_id]) &&
            shouldShowField(item, self.state.ioProductData))
        ) {
          requiredMissing = true;
        }
      });

    this.setState({
      requiredMissing: requiredMissing,
    });
  }

  setFlightSubFieldsMissing(flightSubFieldsMissing) {
    this.setState(
      {
        flightSubFieldsMissing,
      },
      this.checkRequired
    );
  }

  onChange(e, data, fieldId) {
    if (fieldId === "name") {
      this.setState(
        {
          newIoProductName: e.target.value,
        },
        this.checkRequired
      );
    } else if (fieldId === "flights") {
      this.setState(
        {
          flights: data,
        },
        this.checkRequired
      );
    } else {
      // All other fields
      let ioProductData = Object.assign({}, this.state.ioProductData);
      ioProductData[fieldId] = data;

      this.setState(
        {
          ioProductData: ioProductData,
        },
        this.checkRequired
      );

      if (typeof this.props.onChange === "function") {
        this.props.onChange(ioProductData);
      }
    }
  }

  editName() {
    this.setState(
      {
        editingName: true,
      },
      this.checkRequired
    );
  }

  onSelectService(e, data) {
    let service = data.value;

    let option = this.state.ioProductServices.find(function (element) {
      return element.text === service;
    });

    service = option.text;

    this.setState(
      {
        lineItemId: option.key,
        newIoProductService: option.value,
        newIoProductServiceNiceName: service,
        newIoProductName: service,
      },
      function () {
        let self = this;
        let flighted = false;
        let mainService = false;

        // Determine main service (depending on if this is a sub-option)
        Flagship.config.lineItemServices.map(function (item) {
          if (item.value === self.state.newIoProductService) {
            mainService = item.value;
            flighted = item.flighted;
          } else if (item.hasOwnProperty("subOptions")) {
            item.subOptions.map(function (subItem) {
              if (subItem.value === self.state.newIoProductService) {
                mainService = item.value;
                flighted = subItem.flighted;
              }
            });
          }
        });

        Flagship.get(
          "fields/io-product_" + mainService,
          {
            withData: false,
            active: true,
            instance: this.props.instance,
          },
          function (response) {
            if (response.data.success === true) {
              self.setState(
                {
                  ioProductForm: response.data.results,
                  flighted,
                  flightSubFieldsMissing: flighted,
                },
                function () {
                  // Also get child service fields
                  if (mainService !== self.state.newIoProductService) {
                    self.getSubServiceFields();
                  }
                }
              );
            } else {
              Flagship.error(
                "Error getting IO product form from Flagship API server.",
                self.props.recordId,
                self.props.userId
              );
            }
          },
          function (err) {
            Flagship.error(
              "Error getting IO product form from Flagship API server: " + err,
              self.props.recordId,
              self.props.userId
            );
          }
        );
      }
    );
  }

  getSubServiceFields() {
    let self = this;

    // Add sub service fields
    Flagship.get(
      "fields/io-product_" + this.state.newIoProductService,
      {
        active: true,
      },
      function (response) {
        if (response.data.success === true) {
          let combinedForm = [
            ...self.state.ioProductForm,
            ...response.data.results,
          ];

          self.setState({
            ioProductForm: combinedForm,
            trueService: self.state.newIoProductService,
          });
        } else {
          Flagship.error(
            "Error getting IO product form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting IO product form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) !== -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors,
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors,
    });
  }

  saveAndExit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    Flagship.post(
      "io-product/create/" + self.props.recordId,
      {
        io_product_name: self.state.newIoProductName,
        io_product_type: self.state.newIoProductService,
        flights: self.state.flights,
        data: self.state.ioProductData,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.event(
            "create-io-product",
            {
              ioProductId: response.data.ioProductId,
              ioProductKey: response.data.io_product_key,
              ioProductName: self.state.newIoProductServiceNiceName,
              ioProductType: self.state.newIoProductService,
              data: self.state.ioProductData,
            },
            self.props.recordId,
            self.props.userId
          );
          Flagship.notify("IO product added.", "success");
          self.setState(self.getInitialState(), function () {
            if (typeof self.props.onAddIoProduct === "function") {
              self.props.onAddIoProduct();
            }
          });
        } else {
          Flagship.error(
            "Error adding IO product.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error adding IO product: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  render() {
    if (empty(this.state.ioProductForm)) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let self = this;

      return (
        <Modal
          open={true}
          onClose={this.props.cancelAddNew}
          closeIcon
          closeOnDimmerClick={false}
        >
          <Header>
            <Icon name="pin" style={{ display: "inline" }} /> Add New IO Product
            {this.state.newIoProductService !== null ? (
              <Button
                color="grey"
                inverted={true}
                content="Copy RFP Data"
                floated="right"
                icon="copy"
                className="io-copy-from-rfp"
                onClick={this.onCopyFromRFP}
              />
            ) : null}
          </Header>
          <Modal.Content>
            {this.state.newIoProductService === null ? (
              <div>
                <p>
                  Add an IO product for each item that should be executed.
                  <br />
                  Run dates that are flighted should have a separate IO product
                  for each flight.
                </p>
                <Select
                  placeholder="Select a Service from the Proposal..."
                  options={self.state.serviceOptions}
                  onChange={(e, data) => {
                    self.onSelectService(e, data);
                  }}
                />
              </div>
            ) : (
              <div>
                {this.state.editingName === true ? (
                  <Header as="h3" color="grey">
                    <div className="ui input">
                      <input
                        autoFocus
                        placeholder={self.state.newIoProductName}
                        onChange={(e, data) => self.onChange(e, data, "name")}
                        style={{
                          minWidth: "400px",
                          maxWidth: "100%",
                        }}
                      />
                    </div>
                    <span className="margin-left">
                      {" (" + this.state.newIoProductServiceNiceName + ")"}
                    </span>
                  </Header>
                ) : (
                  <Header
                    as="h3"
                    onClick={self.editName}
                    className="hover-dotted-outline"
                  >
                    {self.state.newIoProductName +
                      (self.state.newIoProductName !==
                      this.state.newIoProductServiceNiceName
                        ? "(" + this.state.newIoProductServiceNiceName + ")"
                        : "")}
                  </Header>
                )}

                {this.state.flighted === true ? (
                  <div className="flight-field-container clearfix">
      
                    <FlightField
                      {...this.props.attributes}
                      fields={this.props.options}
                      value={this.state.flights}
                      fieldId="flights"
                      onChange={(e, data) => {
                        this.onChange(e, data, "flights");
                      }}
                      recordType="IO"
                      recordContext="add"
                      email={
                        this.state.newIoProductService === "email-marketing"
                      }
                      callrail={this.state.newIoProductService === "callrail"}
                      social={
                        this.state.newIoProductService === "social-media-ads"
                      }
                      setFlightSubFieldsMissing={this.setFlightSubFieldsMissing}
                    />
                  </div>
                ) : null}

                {this.state.ioProductForm.length &&
                  this.state.ioProductForm.map(function (item, i) {
                    let fieldId = item.field_id;

                    let value = !empty(self.state.ioProductData[fieldId])
                      ? self.state.ioProductData[fieldId]
                      : null;
                    item.default = value;

                    return shouldShowField(item, self.state.ioProductData) ? (
                      <Field
                        contentType="ioProduct"
                        addError={self.addError}
                        clearError={self.clearError}
                        model={"IoProduct." + i}
                        key={"field-" + i}
                        value={value}
                        default={value}
                        filterInput={
                          item.validation !== "" ? item.validation : null
                        }
                        onChange={(e, data, fieldId, misc) =>
                          self.onChange(e, data, fieldId, misc)
                        }
                        setFlightSubFieldsMissing={
                          self.setFlightSubFieldsMissing
                        }
                        {...item}
                      />
                    ) : null;
                  })}
              </div>
            )}
          </Modal.Content>
          <Modal.Actions>
            {this.state.hasCopiedFromRFP === true ? (
              <span className="verify-warning">
                <Icon
                  name="warning"
                  color="red"
                  circular={true}
                  inverted={true}
                />
                &nbsp;Please verify all info from the RFP (and update if
                needed).
              </span>
            ) : null}

            {this.state.requiredMissing === false ? (
              <Button
                disabled={this.state.newIoProductService === null}
                primary
                onClick={this.saveAndExit}
              >
                <Icon name="plus" /> Add IO Product
              </Button>
            ) : (
              <span className="red-text">
                {this.state.flightSubFieldsMissing
                  ? "Missing required flight data."
                  : "Required fields missing."}
              </span>
            )}
            <Button color="grey" onClick={this.props.cancelAddNew}>
              <Icon name="dont" /> Cancel
            </Button>
          </Modal.Actions>
        </Modal>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance,
  };
}

export default connect(mapStateToProps, null)(IoProductForm);



// WEBPACK FOOTER //
// ./src/components/modals/IoProductAddModal.js